import React from 'react';
import PropTypes from 'prop-types';
import { useOverlayTimelineBlocks } from '~/modules/resourcing/common/chart/hooks';
import ResourceRequestUserAllocationBlock from './ResourceRequestUserAllocationBlock';

export const ResourceRequestUserAllocationBlockOverlayPeriod = ({
  scale,
  isEditable,
  chartStartDate,
  chartDisplayDateRange,
  resourceRequest,
  showRequestBlock,
  projectDefaultScheduleRule,
  allocation,
  handleAllocationPeriodClick,
  resourceAvailabilitySummarySeries,
  onAllocationChange,
  showResizeIndicator
}) => {
  const { overlayPeriods } = useOverlayTimelineBlocks({
    chartDisplayDateRange,
    scale,
    allocation
  });

  return (
    <ResourceRequestUserAllocationBlock
      scale={scale}
      isEditable={isEditable}
      showRequestBlock={showRequestBlock}
      chartStartDate={chartStartDate}
      chartDisplayDateRange={chartDisplayDateRange}
      projectDefaultScheduleRule={projectDefaultScheduleRule}
      allocation={allocation}
      resourceRequest={resourceRequest}
      handleAllocationPeriodClick={handleAllocationPeriodClick}
      onAllocationChange={onAllocationChange}
      resourceAvailabilitySummarySeries={resourceAvailabilitySummarySeries}
      showResizeIndicator={showResizeIndicator}
      overlayPeriods={overlayPeriods}
    />
  );
};

ResourceRequestUserAllocationBlockOverlayPeriod.propTypes = {
  scale: PropTypes.string.isRequired,
  resourceRequest: PropTypes.object,
  projectDefaultScheduleRule: PropTypes.object.isRequired,
  allocation: PropTypes.object,
  handleAllocationPeriodClick: PropTypes.func,
  resourceAvailabilitySummarySeries: PropTypes.array,
  chartDisplayDateRange: PropTypes.object,
  showRequestBlock: PropTypes.bool,
  isEditable: PropTypes.bool,
  showResizeIndicator: PropTypes.bool,
  onAllocationChange: PropTypes.func.isRequired,
  chartStartDate: PropTypes.object
};

export default ResourceRequestUserAllocationBlockOverlayPeriod;
